// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3-ctD","signatureButtonsRight":"ModalSign_signatureButtonsRight__2pYq4"};